import {
  AccordionDetails,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import { useStyles } from "./styles";
import RemoveIcon from "@mui/icons-material/Remove";

import React, { useRef } from "react";
import useStudent from "../../../../../Hooks/student";
import CustomExpandMore from "../../../../../common/CustomExpandMore";
import * as Yup from "yup";
import { useLocation } from "react-router-dom";

// const phoneRegExp = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/;
const phoneRegExp = /^(?=.*[0-9]).{10,10}$/;

export const parentalInfoSchema = Yup.object().shape({
  type: Yup.string().required("* Please select relation"),
  name: Yup.string().required("* Please enter name"),
  mobile: Yup.string()
    .matches(phoneRegExp, {
      message: "* Phone number is not valid",
      excludeEmptyString: true,
    })
    .required("* Please enter mobile number"),
  job: Yup.string().required("* Please enter job"),
  jobAddress: Yup.string().required("* Please enter job address"),
  address: Yup.string().required("* Please enter address"),
  email: Yup.string()
    .email("* Enter valid email")
    .required("* Please enter email"),
});

const ParentalInfo = (props) => {
  const { currentIndex, contactRef, id } = props;
  const {
    removeParentalInfoAction,
    updateParentalInfoDataAction,
    addStudentContactsAction,
    studentPersonalInfo,
    studentParentalInfo,
    addParentalInfoAction,
    studentDetails,
    deleteContactAction,
  } = useStudent();

  const studentParentalInfoData = {
    idStudent:
      studentParentalInfo && studentParentalInfo[currentIndex]?.idStudent
        ? studentParentalInfo[currentIndex]?.idStudent
        : studentDetails?.id,
    type: studentParentalInfo[currentIndex]?.type || "",
    mobile: studentParentalInfo[currentIndex]?.mobile || "",
    address: studentParentalInfo[currentIndex]?.address || "",
    job: studentParentalInfo[currentIndex]?.job || "",
    jobAddress: studentParentalInfo[currentIndex]?.jobAddress || "",
    name: studentParentalInfo[currentIndex]?.name || "",
    id: studentParentalInfo[currentIndex]?.id || "",
    email: studentParentalInfo[currentIndex]?.email || "",
  };

  const classes = useStyles();

  return (
    <Stack
      sx={{ border: "1px solid #D1D5DB", mb: 2, borderRadius: "23px" }}
      id={id}
    >
      <Stack>
        <Stack
          sx={{
            color: "#25D5A1",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Stack
            sx={{
              width: "80px",
              height: "80px",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              borderRadius: "50px",
            }}
            onClick={() => {
              removeParentalInfoAction({ key: currentIndex });
              deleteContactAction({
                id: studentParentalInfo[currentIndex]?.id,
              });
            }}
          >
            <RemoveIcon />
          </Stack>
        </Stack>
        <Formik
          validationSchema={parentalInfoSchema}
          initialValues={studentParentalInfoData}
          validateOnBlur={false}
          validateOnChange={false}
          innerRef={contactRef}
          enableReinitialize
          onSubmit={(values) => {}}
        >
          {(formik) => {
            const { errors, touched, handleChange, handleSubmit, values } =
              formik;
            return (
              <>
                <form id="studentParentalInfo" onSubmit={handleSubmit}>
                  <AccordionDetails>
                    <Grid
                      container
                      spacing={3}
                      sx={{ flexDirection: "column" }}
                    >
                      <Grid item md={12} sm={12} sx={{ display: "flex" }}>
                        <Grid
                          sx={{
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "space-around",
                            gap: 2,
                            mb: 2,
                          }}
                          container
                        >
                          <Stack>
                            <Select
                              id="type"
                              name="type"
                              IconComponent={CustomExpandMore}
                              onChange={(e) => {
                                handleChange(e);
                                updateParentalInfoDataAction({
                                  type: "type",
                                  index: currentIndex,
                                  data: e.target.value,
                                });
                              }}
                              sx={{ width: 250 }}
                              displayEmpty
                              value={values.type}
                            >
                              <MenuItem value="" disabled>
                                <span>Select Relation</span>
                              </MenuItem>
                              <MenuItem value="Father">Father</MenuItem>
                              <MenuItem value="Mother">Mother</MenuItem>
                              <MenuItem value="Guardian">Guardian</MenuItem>
                            </Select>
                            <ErrorMessage
                              name="type"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                          <Stack>
                            <TextField
                              id="name"
                              name="name"
                              placeholder="Enter name"
                              className={
                                errors.name && touched.name
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onChange={(e) => {
                                handleChange(e);
                                updateParentalInfoDataAction({
                                  type: "name",
                                  index: currentIndex,
                                  data: e.target.value,
                                });
                              }}
                              value={values.name}
                            />
                            <ErrorMessage
                              name="name"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                          <Stack>
                            <TextField
                              id="email"
                              name="email"
                              placeholder="Enter email"
                              className={
                                errors.email && touched.email
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onChange={(e) => {
                                handleChange(e);
                                updateParentalInfoDataAction({
                                  type: "email",
                                  index: currentIndex,
                                  data: e.target.value,
                                });
                              }}
                              value={values.email}
                            />
                            <ErrorMessage
                              name="email"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                          <Stack>
                            <TextField
                              id="mobile"
                              name="mobile"
                              type="number"
                              placeholder="Enter mobile"
                              // onChange={handleChange}
                              value={values.mobile}
                              className={
                                errors.mobile && touched.mobile
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onChange={(e) => {
                                handleChange(e);
                                updateParentalInfoDataAction({
                                  type: "mobile",
                                  index: currentIndex,
                                  data: e.target.value,
                                });
                              }}
                            />
                            <ErrorMessage
                              name="mobile"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Grid>
                        <Grid
                          sx={{
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "space-around",
                            gap: 2,
                            mb: 2,
                          }}
                          container
                        >
                          <Stack>
                            <TextField
                              id="job"
                              name="job"
                              placeholder="Enter job"
                              className={
                                errors.job && touched.job
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onChange={(e) => {
                                handleChange(e);
                                updateParentalInfoDataAction({
                                  type: "job",
                                  index: currentIndex,
                                  data: e.target.value,
                                });
                              }}
                              value={values.job}
                            />
                            <ErrorMessage
                              name="job"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>

                          <Stack>
                            <TextField
                              id="jobAddress"
                              name="jobAddress"
                              placeholder="Enter job address"
                              className={
                                errors.jobAddress && touched.jobAddress
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onChange={(e) => {
                                handleChange(e);
                                updateParentalInfoDataAction({
                                  type: "jobAddress",
                                  index: currentIndex,
                                  data: e.target.value,
                                });
                              }}
                              value={values.jobAddress}
                            />
                            <ErrorMessage
                              name="jobAddress"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                          <Stack>
                            <TextField
                              id="address"
                              name="address"
                              placeholder="Enter address"
                              className={
                                errors.address && touched.address
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onChange={(e) => {
                                handleChange(e);
                                updateParentalInfoDataAction({
                                  type: "address",
                                  index: currentIndex,
                                  data: e.target.value,
                                });
                              }}
                              value={values.address}
                            />
                            <ErrorMessage
                              name="address"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Grid>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </form>
              </>
            );
          }}
        </Formik>
      </Stack>
    </Stack>
  );
};

export default ParentalInfo;
